import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => (x.loc?.length ? `${x.loc.slice(-1)[0]}: ${x.msg}` : x.msg)).join(", ");
  if (d?.errors) return d.errors.map((x) => `Row ${x.index + 1}: ${x.message}`).join("; ");
  return d || e?.message || "Something went wrong";
};

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, path, data, config = {}) => {
      const token = await getToken();
      const res = await axios({ method, url: `${API}${path}`, data, ...config, headers: { Authorization: `Bearer ${token}` } });
      return res.data;
    },
    [getToken]
  );
}

export function useResource(path) {
  const api = useApi();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const reload = useCallback(async () => {
    if (!path) return;
    try {
      setData(await api("get", path));
      setError(null);
    } catch (e) {
      setError(errorText(e));
    }
  }, [api, path]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { data, error, reload, setData };
}
